// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { screenSmMax } from '@spotify-internal/encore-foundation';
import { RelatedLink } from './RelatedLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RelatedLinks = styled.div.withConfig({
  displayName: "RelatedLinksModule__RelatedLinks",
  componentId: "sc-1op02kt-0"
})(["display:flex;.relatedLink1{background-color:", ";color:", ";width:50%;@media (max-width:", "){width:100%;}}.relatedLink2{background-color:", ";color:", ";width:50%;@media (max-width:", "){width:100%;}}@media (max-width:", "){flex-direction:column;width:100%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.box.tileOneBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
}, screenSmMax, function (_ref3) {
  var theme = _ref3.theme;
  return theme.box.tileTwoBackground;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.box.text;
}, screenSmMax, screenSmMax);
export var RelatedLinksModule = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var _ref5$relatedLink = _ref5.relatedLink1,
      relatedLink1 = _ref5$relatedLink === void 0 ? {
    headline: '',
    subtext: '',
    description: '',
    linkText: '',
    link: ''
  } : _ref5$relatedLink,
      _ref5$relatedLink2 = _ref5.relatedLink2,
      relatedLink2 = _ref5$relatedLink2 === void 0 ? {
    headline: '',
    subtext: '',
    description: '',
    linkText: '',
    link: ''
  } : _ref5$relatedLink2;
  return /*#__PURE__*/_jsxs(RelatedLinks, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "relatedLink1",
      children: /*#__PURE__*/_jsx(RelatedLink, {
        ref: ref,
        relatedLink: relatedLink1
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "relatedLink2",
      children: /*#__PURE__*/_jsx(RelatedLink, {
        ref: ref,
        relatedLink: relatedLink2
      })
    })]
  });
});